/* eslint-disable import/no-extraneous-dependencies */
import { io, Socket } from "socket.io-client";
import { useAuthStore, useCompanyStore } from "../store";

let socket: Socket | null = null;

export function getSocketConnection(): Socket {
  const companyId =
    sessionStorage.getItem("companyId") ||
    useCompanyStore.getState().companyData?.id ||
    "";
  if (!socket) {
    socket = io(process.env.REACT_APP_OPTIONS_API, {
      auth: {
        accessToken: useAuthStore.getState().accessToken,
      },
      query: {
        companyId,
      },
      transports: ["websocket"],
    });
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
